import L from 'leaflet';

export const doLinesIntersect = (p1: L.LatLng, p2: L.LatLng, p3: L.LatLng, p4: L.LatLng) => {
  const ccw = (A: L.LatLng, B: L.LatLng, C: L.LatLng) => {
    return (C.lat - A.lat) * (B.lng - A.lng) > (B.lat - A.lat) * (C.lng - A.lng);
  };
  return (
    ccw(p1, p3, p4) !== ccw(p2, p3, p4) &&
    ccw(p1, p2, p3) !== ccw(p1, p2, p4)
  );
};

export const isPolygonValid = (points: L.LatLng[]) => {
  for (let i = 0; i < points.length - 1; i++) {
    for (let j = i + 1; j < points.length; j++) {
      if (i !== j) {
        if (doLinesIntersect(points[i], points[(i + 1) % points.length], points[j], points[(j + 1) % points.length])) {
          return false;
        }
      }
    }
  }
  return true;
};
